import memoizeOne from 'memoize-one';

import { featureFlags } from 'utils/featureFlagging/featureFlags';

/** Checks if shared workers are supported the feature flag is enabled */
export const getUseSharedWorker = memoizeOne(async (): Promise<boolean> => {
  try {
    if (!('SharedWorker' in window)) {
      return false;
    }

    const { useSharedWorker } = featureFlags.get(['use-shared-worker']);

    // Default to false if feature flag isn't returned
    return useSharedWorker ?? false;
  } catch (error) {
    console.warn(error);
    return false;
  }
});
